import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getImageCoverageInsightForEntity } from 'apis/merchant-gateway/insights/image-coverage/api';
import { ImageCoverageSortable } from 'apis/merchant-gateway/insights/image-coverage/types';
import { EntityType } from 'common/types';

import { SortOrder } from '../components/tables/types';

type UseImageCoverageInsightsParams = {
  entityType: EntityType;
  entityId: string;
  sortBy: ImageCoverageSortable;
  sortOrder: SortOrder;
};

const useImageCoverageInsights = ({ entityType, entityId, sortOrder, sortBy }: UseImageCoverageInsightsParams) => {
  const { data, ...rest } = useInfiniteQuery({
    queryKey: ['image-coverage-insights', entityId, entityType, sortOrder, sortBy],
    queryFn: async ({ pageParam: encodedCursor }) =>
      getImageCoverageInsightForEntity({ entityType, entityId, sortOrder, sortBy, encodedCursor }),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    getNextPageParam: lastPage => lastPage?.pagination?.next,
    retry: false,
  });

  const imageCoverageRecords = useMemo(() => {
    // flatten the pages and map label to id for each record
    return data?.pages.flatMap(page => page.data.split.map(record => ({ ...record, id: record.label }))) ?? [];
  }, [data]);

  return {
    ...rest,
    imageCoverageRecords,
  };
};

export default useImageCoverageInsights;
